"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Loader = function (_a) {
    var _b = _a.spinning, spinning = _b === void 0 ? true : _b, _c = _a.fullScreen, fullScreen = _c === void 0 ? true : _c;
    return (react_1.default.createElement("div", { className: classnames_1.default('loader', {
            hidden: !spinning,
            fullscreen: fullScreen,
        }) }));
};
exports.default = Loader;
//# sourceMappingURL=index.js.map